import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    DateDetails:"",
}

const DateDetailSlice = createSlice({
    name: "DateDetailSlice",
    initialState,

    reducers: {
        DateDetailsData(state, action) {
            return {
                DateDetails:action.payload.DateDetails,
            };
        }
    }
})
export const { DateDetailsData } = DateDetailSlice.actions;
export default DateDetailSlice.reducer;